// @flow

import React from 'react';
import { RotationControl } from 'react-mapbox-gl';
import ZoomControl from './zoom';
import PitchControl from './pitch';
import './index.css';

const styleReset = {
  position: null,
  zIndex: null,
  boxShadow: null,
  border: null,
  top: null,
  right: null,
  bottom: null,
  left: null,
};

const Controls = () => (
  <div className="mapboxgl-controls">
    <ZoomControl className="zoom-control" style={styleReset} />
    <RotationControl style={styleReset} />
    <PitchControl />
  </div>
);

export default Controls;



// WEBPACK FOOTER //
// ./src/controls/index.js